var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEye(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Large/Eye"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M20.0711 10.2469C20.0437 10.1852 19.382 8.71719 17.9109 7.24609C15.9508 5.28594 13.475 4.25 10.75 4.25C8.02499 4.25 5.54921 5.28594 3.58905 7.24609C2.11796 8.71719 1.45312 10.1875 1.4289 10.2469C1.39336 10.3268 1.375 10.4133 1.375 10.5008C1.375 10.5883 1.39336 10.6748 1.4289 10.7547C1.45624 10.8164 2.11796 12.2836 3.58905 13.7547C5.54921 15.7141 8.02499 16.75 10.75 16.75C13.475 16.75 15.9508 15.7141 17.9109 13.7547C19.382 12.2836 20.0437 10.8164 20.0711 10.7547C20.1066 10.6748 20.125 10.5883 20.125 10.5008C20.125 10.4133 20.1066 10.3268 20.0711 10.2469ZM10.75 15.5C8.3453 15.5 6.24452 14.6258 4.50546 12.9023C3.7919 12.1927 3.18483 11.3836 2.70312 10.5C3.1847 9.61636 3.79179 8.80717 4.50546 8.09766C6.24452 6.37422 8.3453 5.5 10.75 5.5C13.1547 5.5 15.2555 6.37422 16.9945 8.09766C17.7095 8.807 18.3179 9.61619 18.8008 10.5C18.2375 11.5516 15.7836 15.5 10.75 15.5ZM10.75 6.75C10.0083 6.75 9.28329 6.96993 8.6666 7.38199C8.04992 7.79404 7.56927 8.37971 7.28544 9.06494C7.00162 9.75016 6.92735 10.5042 7.07205 11.2316C7.21674 11.959 7.57389 12.6272 8.09834 13.1517C8.62279 13.6761 9.29097 14.0333 10.0184 14.1779C10.7458 14.3226 11.4998 14.2484 12.1851 13.9645C12.8703 13.6807 13.4559 13.2001 13.868 12.5834C14.2801 11.9667 14.5 11.2417 14.5 10.5C14.499 9.50576 14.1035 8.55253 13.4005 7.84949C12.6975 7.14645 11.7442 6.75103 10.75 6.75ZM10.75 13C10.2555 13 9.77219 12.8534 9.36107 12.5787C8.94994 12.304 8.62951 11.9135 8.44029 11.4567C8.25107 10.9999 8.20157 10.4972 8.29803 10.0123C8.39449 9.52732 8.63259 9.08186 8.98222 8.73223C9.33186 8.3826 9.77731 8.1445 10.2623 8.04804C10.7472 7.95157 11.2499 8.00108 11.7067 8.1903C12.1635 8.37952 12.554 8.69995 12.8287 9.11107C13.1034 9.5222 13.25 10.0055 13.25 10.5C13.25 11.163 12.9866 11.7989 12.5178 12.2678C12.0489 12.7366 11.413 13 10.75 13Z",
    fill: "url(#paint0_linear_259_5987)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_259_5987",
    x1: 20.125,
    y1: 4.25,
    x2: 1.375,
    y2: 4.25,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E28A9C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.385417,
    stopColor: "#D378F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A9CFF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEye);
export default __webpack_public_path__ + "static/media/Eye.01336788da2542839f7b7102018b58b9.svg";
export { ForwardRef as ReactComponent };